import { getAppConfig } from "@core/config";

export const changeHost = (src: string): string => {
  const CDN_DOMAIN = getAppConfig().CDNDomain;
  if (!CDN_DOMAIN) return src;
  try {
    const url = new URL(src);
    url.host = CDN_DOMAIN;
    return url.href;
  } catch {
    return src;
  }
};
